import { push } from "connected-react-router";
import Logo from "pages/login/_components/Logo";
import LogoTitle from "pages/login/_components/LogoTitle";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { actions as loginActions } from "reducers/login";
import ErrorPopup from "../_components/ErrorPopup";
import UserForm from "./_components/UserForm";
import NewVersionApplication from "./NewVersionApplication";
import LoginFooter from "../footer";

const LoginUser = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const [initialized, setInitialized] = useState(false);
    const [error, setError] = useState("");
    useEffect(() => {
        if (!initialized && !!dispatch) {
            dispatch(loginActions.initLoginFlow());
            setInitialized(true);
            window.common.hideSplashScreen();
            setError("");
        }
    }, [initialized, setInitialized, dispatch, setError]);

    const getDesktopView = () => (
        <>
            <div className="text-center">
                <Logo className="svg-image logo logo-large" />
            </div>

            <I18n component="h1" componentProps={{ className: "text-center" }} id="onboarding.welcome" />

            <div>
                <div className="mb-6">
                    <UserForm isDesktop={isDesktop} />
                </div>
                <Button
                    className="btn-outline"
                    onClick={() => {
                        dispatch(push("/loginRegister"));
                    }}
                    label="onboarding.signIn"
                    defaultLabelText="Quiero ser cliente"
                    block
                />
            </div>
            <LoginFooter />
        </>
    );

    const getMobileView = () => (
        <Container className="items-center container--layout">
            <I18n component="h1" componentProps={{ className: "text-center mb-8" }} id="onboarding.welcome" />
            <UserForm isDesktop={isDesktop} />
            <Button
                bsStyle="outline"
                onClick={() => {
                    dispatch(push("/loginRegister"));
                }}
                label="onboarding.signIn"
                defaultLabelText="Quiero ser cliente"
                block
            />
            <LoginFooter token isDesktop={isDesktop} />
            {window.cordova && <NewVersionApplication />}
        </Container>
    );

    return (
        <>
            <Notification scopeToShow="login" />
            <ErrorPopup error={error} />
            <LogoTitle isDesktop={isDesktop} />
            <MainContainer>{isDesktop ? getDesktopView() : getMobileView()}</MainContainer>
        </>
    );
};

LoginUser.propTypes = {
    isDesktop: bool.isRequired,
};

export default withRouter(LoginUser);
